import {
  createSvgIcon,
  Grid,
  MenuItem,
  Select,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import React, { useState, useRef } from "react";
import Title from "../ReusableComponents/title";
import "../../assets/css/SupportCenter.scss";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import CombinedPopup from "../Popups/CombinedPopup";
import logoutReducer from "../../store/reducers/logout";
import { axiosInstance } from "../../Axios";
import { tokenConfig } from "../../store/reducers/tokenReducer";
import { myStore } from "../..";

const Account = () => {
  return (
    <div className="RadioLabel gapp-10 d-flex">
      <div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            fill="white"
            stroke="#8B8E93"
            strokeWidth="6"
          />
        </svg>
      </div>
      <div>
        <Title four>Account and billing support</Title>
        <Title three>
          Assistance with account and billing - related inquiries
        </Title>
      </div>
    </div>
  );
};
const Feedback = () => {
  return (
    <div className="RadioLabel gapp-10 d-flex">
      <div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            fill="white"
            stroke="#8B8E93"
            strokeWidth="6"
          />
        </svg>
      </div>
      <div>
        <Title four>Feedback</Title>
        <Title three>
          Requested to increase the service limit of your resources
        </Title>
      </div>
    </div>
  );
};
const Technical = () => {
  return (
    <div className="RadioLabel gapp-10 d-flex">
      <div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            fill="white"
            stroke="#8B8E93"
            strokeWidth="6"
          />
        </svg>
      </div>
      <div>
        <Title four>Technical support</Title>
        <Title three>
          Service - relateed technical issues and third party applications
        </Title>
      </div>
    </div>
  );
};

const Attach = createSvgIcon(
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.958252 3.83333C0.958252 2.06142 2.39467 0.625 4.16659 0.625H13.4846C14.1423 0.625 14.7597 0.941835 15.1432 1.47614L18.6586 6.37369C18.9076 6.72069 19.0416 7.13708 19.0416 7.56422V20.1667C19.0416 21.9386 17.6052 23.375 15.8333 23.375H4.16659C2.39467 23.375 0.958252 21.9386 0.958252 20.1667V3.83333ZM4.16659 2.375C3.36117 2.375 2.70825 3.02792 2.70825 3.83333V20.1667C2.70825 20.9721 3.36117 21.625 4.16659 21.625H15.8333C16.6387 21.625 17.2916 20.9721 17.2916 20.1667V8.37989H13.4999C13.0167 8.37989 12.6249 7.98814 12.6249 7.50489V2.375H4.16659Z"
      fill="white"
    />
    <path
      d="M13.5999 13.4216C13.298 13.799 12.7474 13.8601 12.37 13.5583L10.875 12.3622V16.375C10.875 16.8582 10.4832 17.25 9.99998 17.25C9.51674 17.25 9.12498 16.8582 9.12498 16.375V12.3622L7.62989 13.5583C7.25254 13.8601 6.70191 13.799 6.40002 13.4216C6.09814 13.0443 6.15932 12.4936 6.53668 12.1917L9.45023 9.86089C9.5987 9.74086 9.78722 9.66839 9.99261 9.6667C9.99506 9.66668 9.99752 9.66667 9.99998 9.66667L10.0028 9.66667C10.2118 9.66733 10.4035 9.74124 10.5536 9.86406L13.4632 12.1917C13.8406 12.4936 13.9018 13.0443 13.5999 13.4216Z"
      fill="white"
    />
  </svg>
);

const CreateCase = () => {
  const fileref = useRef(null);
  const [Type, setType] = useState("");
  const [Category, setCategory] = useState("");
  const [Severity, setSeverity] = useState("");
  const [Subject, setSubject] = useState("");
  const [Description, setDescription] = useState("");
  const [Attachment, setAttachment] = useState();
  const [Radio, setRadio] = useState();
  const [SubLength, setSubLength] = useState(250);
  const [err, setErr] = useState();

  const dispatch = useDispatch();

  const handleChangeType = (event) => {
    setType(event.target.value);
  };
  const handleChangeCategory = (event) => {
    setCategory(event.target.value);
  };
  const handleChangeSeverity = (event) => {
    setSeverity(event.target.value);
  };
  const handleChangeDescription = (event) => {
    setDescription(event.target.value);
  };
  const handleChangeSubject = (event) => {
    setSubject(event.target.value);
    let len = 250 - Subject.length;
    setSubLength(len);
    const msg = "Subject is too big";
    if (Subject.length > 250) {
      setErr(msg);
    } else if (Subject.length <= 250) {
      setErr("");
    }
  };
  const handleChangeAttachment = (event) => {
    // setAttachment(event.target.files[0])
    if (event.target.files && event.target.files[0]) {
      setAttachment(event.target.files[0]);
    }
    // var file = fileref.current.files[0];
    // var reader = new FileReader();
    // var url = reader.readAsDataURL(file);

    // reader.onloadend = function (e) {
    //   setPreview(reader.result);
    // }.bind(this);
  };

  const handleChangeRadio = (event) => {
    setRadio(event.target.value);
  };
  const [showPopup, setShowPopup] = useState(false);
  const [combinedPUHead, setCombinedPUHead] = useState("");
  const [combinedPUBody, setCombinedPUBody] = useState("");
  const [popUpType, setPopUpType] = useState("");
  const ACCtoken = useSelector((state) => state.ACCtoken);
  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      Category === "" ||
      Subject === "" ||
      Type === "" ||
      Severity === "" ||
      Radio === "" ||
      Subject === "" ||
      Description === ""
    ) {
      // setShowPopup(true)
      // setPopUpType('error')
      // setCombinedPUHead('Oh snap!')
      // setCombinedPUBody('Please fill all the fields')
      // return
      alert(Category);
    }

    let form_data = new FormData();
    if (typeof Attachment === "object") {
      form_data.append("attachment", Attachment);
    }
    form_data.append("Case_Type", Radio);
    form_data.append("Type", Type);
    form_data.append("category", Category);
    form_data.append("severity", Severity);
    form_data.append("subject", Subject);
    form_data.append("description", Description);
    form_data.append("idToken", ACCtoken);

    // const Formdata = {
    //   Case_Type: Radio,
    //   Type: Type,
    //   category: Category,
    //   severity: Severity,
    //   subject: Subject,
    //   description: Description,
    //   attachment: Attachment,
    //   idToken: ACCtoken,
    // }
    axiosInstance
      .post(`/v2/support/cases/create/`, tokenConfig(myStore.getState), form_data)
      .then((res) => {
        console.log("====================================");
        console.log(res);
        console.log("====================================");
        if (res.data === "No Cases found!") {
          alert("No Cases found!");
          return;
        }
        if (res.data === "Please verify the Access Token!") {
          dispatch(logoutReducer());
          return;
        }
        // if( Attachment.size <= 25000000) {
        //   alert("hi")
        // }
        // alert('Case Created Successfully!')

        setShowPopup(true);
        setPopUpType("success");
        setCombinedPUHead("Woo hoo !");
        setCombinedPUBody("Case created successfully");
        return;

        // console.log(res.datas.data);
      })
      .catch(function (error) {});
  };

  const onClickCross = () => {
    window.location.reload();
  };

  return (
    <div>
      <CombinedPopup
        type={popUpType}
        trigger={showPopup}
        setTrigger={setShowPopup}
        head={combinedPUHead}
        subhead={combinedPUBody}
        onClick={onClickCross}
      />
      <div
        className="CreateCaseContainer"
        style={{ border: "none", padding: "10px" }}
      >
        <div className="CreateCaseNav">
          <Title six>Create case</Title>
        </div>
        <form
          className="CreateCaseDesk"
          onSubmit={handleSubmit}
          style={{ width: "100%" }}
        >
          <Grid container item spacing={2}>
            <Grid item container className="RadioSec" spacing={1}>
              <Grid item xs={12} md={4}>
                <input
                  type="radio"
                  id="account"
                  name="radio"
                  value="Account & Billing Support"
                  onChange={handleChangeRadio}
                />
                <label htmlFor="account" style={{ width: "100%" }}>
                  <Account />
                </label>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="radio"
                  id="feedback"
                  name="radio"
                  value="Feedback"
                  onChange={handleChangeRadio}
                />
                <label htmlFor="feedback" style={{ width: "100%" }}>
                  <Feedback />
                </label>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="radio"
                  id="technical"
                  name="radio"
                  value="Technical Support"
                  onChange={handleChangeRadio}
                />
                <label htmlFor="technical" style={{ width: "100%" }}>
                  <Technical />
                </label>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              container
              className="mtt-20"
              justifyContent="space-between"
              spacing={2}
            >
              <Grid item xs={12} md={4}>
                <Title three>Type</Title>
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Type}
                  onChange={handleChangeType}
                >
                  <MenuItem value="Competition">Competition</MenuItem>
                  <MenuItem value="Evaluation Account">
                    Evaluation Account
                  </MenuItem>
                  <MenuItem value="Funded Account">Funded Account</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={12} md={4}>
                <Title three>Category</Title>
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Category}
                  onChange={handleChangeCategory}
                >
                  <MenuItem value="Account">Account</MenuItem>
                  <MenuItem value="Billing">Billing</MenuItem>
                  <MenuItem value="Bug">Bug</MenuItem>
                  <MenuItem value="Technical">Technical</MenuItem>
                  <MenuItem value="General">General</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={12} md={4}>
                <Title three>Severity</Title>
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Severity}
                  onChange={handleChangeSeverity}
                >
                  <MenuItem value="High">High</MenuItem>
                  <MenuItem value="Medium">Medium</MenuItem>
                  <MenuItem value="Low">Low</MenuItem>
                </Select>
              </Grid>
            </Grid>
            <Grid container item xs={12} className="" spacing={2}>
              <Grid item xs={12} md={8}>
                <Title three>Subject</Title>
                <TextField
                  fullWidth
                  placeholder="Brief summary of the question or issue"
                  value={Subject}
                  onChange={handleChangeSubject}
                />
                <Title three>
                  Maximum 250 characters( <span>{SubLength}</span> remaining){" "}
                  <span style={{ color: "#FD504F" }}> {err}</span>
                </Title>
              </Grid>
              <Grid
                item
                className="AttachFile"
                xs={12}
                md={4}
                style={{ height: "100px" }}
              >
                <Title three>Attachment</Title>
                <Grid container className="FileUpload">
                  <Grid>
                    <Attach />
                  </Grid>
                  <Grid>
                    <span>
                      {Attachment && Attachment.name
                        ? Attachment.name
                        : "Choose file"}
                    </span>
                  </Grid>
                </Grid>
                {/* <input type="file"
                  value={Attachment}
                  onChange={handleChangeAttachment} /> */}
                <TextField
                  className="AttachInput"
                  type="file"
                  fullWidth
                  ref={fileref}
                  // value={Attachment}
                  onChange={handleChangeAttachment}
                />
              </Grid>
            </Grid>
            <Grid item className="DescArea" xs={12}>
              <Title three>Description</Title>
              <TextareaAutosize
                placeholder="Detailed account of the question or issue"
                style={{ width: "100%" }}
                onChange={handleChangeDescription}
              />
              <Title three>Maximum 2000 characters(2000 remaining)</Title>
            </Grid>
            <Grid
              container
              justifyContent="center"
              className="CreateButton mtt-20"
            >
              <button>Create case</button>
            </Grid>
          </Grid>
        </form>
      </div>
    </div>
  );
};

export default CreateCase;
